export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  author: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '娱乐爆料', slug: 'yule', icon: 'ri-movie-2-line', description: '娱乐圈最新八卦、明星动态、综艺内幕' },
  { name: '社会热点', slug: 'shehui', icon: 'ri-fire-line', description: '社会民生、热点事件、深度调查' },
  { name: '科技数码', slug: 'keji', icon: 'ri-smartphone-line', description: '科技前沿、数码产品、互联网动态' },
  { name: '财经内幕', slug: 'caijing', icon: 'ri-money-cny-circle-line', description: '财经资讯、商业内幕、投资风向' },
  { name: '生活趣闻', slug: 'shenghuo', icon: 'ri-heart-line', description: '生活百态、趣闻轶事、实用分享' },
  { name: '体育赛事', slug: 'tiyu', icon: 'ri-basketball-line', description: '体育赛事、运动明星、赛场内幕' },
];

export const articles: Article[] = [
  {
    id: '1',
    title: '某知名艺人深夜密会神秘女子，酒店同框照曝光引发粉丝热议',
    excerpt: '据知情人士透露，该艺人近期与一位圈外女子频繁互动，两人被拍到在某五星级酒店同时出现，举止亲密。此事一经曝光立即在社交平台引发广泛讨论。',
    content: `<p>近日，一则关于某知名艺人的爆料在网络上迅速传播。据多位目击者称，该艺人于上周五深夜被拍到与一名神秘女子共同进入某五星级酒店，两人全程举止亲密，直至次日清晨才分别离开。</p><p>消息人士透露，该女子并非圈内人士，而是一名从事金融行业的白领。两人据称已经交往数月，但一直未对外公开。此次被拍到的画面中，该艺人戴着口罩和帽子，显然试图掩饰身份，但仍被眼尖的网友认出。</p><p>这一爆料迅速在各大社交平台引发热议。粉丝们反应不一，有人表示祝福，也有人表示难以接受。截至目前，该艺人及其团队尚未对此事作出任何回应。</p><p>业内人士分析认为，在当前的舆论环境下，艺人私生活的曝光往往会对其商业价值产生直接影响。如果处理不当，可能会导致代言合约的流失。</p><p>我们将持续关注此事的后续发展。</p>`,
    category: '娱乐爆料',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20with%20mysterious%20atmosphere%2C%20night%20hotel%20scene%20with%20blurred%20figures%2C%20paparazzi%20style%20photography%2C%20warm%20dark%20tones%2C%20dramatic%20lighting%2C%20editorial%20photo%20journalism%20style%20with%20soft%20ambient%20light%20and%20motion%20blur%2C%20high%20contrast%20shadows&width=800&height=500&seq=article-1-ent&orientation=landscape',
    author: '娱乐观察员',
    publishDate: '2026-08-04',
    viewCount: 125830,
    commentCount: 3421,
    tags: ['明星', '恋情曝光', '娱乐圈', '热议'],
    isHot: true,
    isNew: true,
  },
  {
    id: '2',
    title: '某互联网大厂被曝裁员30%，内部员工爆料补偿方案引争议',
    excerpt: '多位自称是该公司员工的网友在社交平台发帖称，公司正在进行大规模人员优化，涉及多个核心业务部门。部分员工对补偿方案表示不满，已在内部发起联名申诉。',
    content: `<p>据多位内部员工爆料，某知名互联网企业近期启动了大规模裁员计划，涉及比例高达30%，波及多个核心业务部门。此次裁员据称是公司战略调整的一部分，旨在优化业务结构，降低运营成本。</p><p>一位不愿透露姓名的员工向本报表示："周一早上刚上班就收到了HR的通知，整个部门被砍掉了将近一半。虽然公司给出了N+3的补偿方案，但很多人都是刚买房或有家庭负担的，这个补偿方案并不让人满意。"</p><p>据悉，此次裁员主要集中在非核心业务线，包括内容运营、市场推广和部分技术岗位。公司内部已经出现了联名申诉的情况，部分员工要求提高补偿标准。</p><p>行业分析师指出，互联网行业正在经历一轮深度调整期，多家头部企业都在进行不同程度的人员优化。这反映了整个行业从高速增长转向高质量发展的趋势。</p><p>截至目前，该公司官方尚未对此事作出正式回应。</p>`,
    category: '科技数码',
    categorySlug: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20office%20building%20exterior%20with%20rainy%20mood%2C%20corporate%20atmosphere%2C%20business%20district%20scene%20with%20reflective%20glass%20windows%2C%20overcast%20weather%2C%20dramatic%20clouds%2C%20editorial%20photography%20style%20with%20cool%20neutral%20tones&width=800&height=500&seq=article-2-tech&orientation=landscape',
    author: '科技前线',
    publishDate: '2026-08-03',
    viewCount: 98420,
    commentCount: 2856,
    tags: ['互联网', '裁员', '大厂', '职场'],
    isHot: true,
    isNew: true,
  },
  {
    id: '3',
    title: '某地级市领导涉嫌严重违纪被调查，涉案金额或达数亿元',
    excerpt: '据权威消息源透露，该市多名领导干部已被纪委监委带走协助调查，案件涉及土地出让、工程招标等多个领域。此案或将成为该省今年反腐第一大案。',
    content: `<p>据权威渠道消息，某地级市多名领导干部因涉嫌严重违纪违法，已于近日被纪委监委带走协助调查。此案涉及范围之广、涉案金额之大在该省近年来较为罕见。</p><p>知情人士透露，案件主要涉及土地出让、工程建设招标、国有资产处置等多个领域。初步调查显示，涉案金额可能高达数亿元，已有超过十名相关人员被采取留置措施。</p><p>当地一位不愿透露姓名的公务员表示："这次的动作非常大，很多人都没想到。省纪委的人来得很突然，当天就直接从办公室把人带走了。"</p><p>分析人士指出，此案反映出中央反腐力度持续加大的态势。今年以来，全国已有多个地级市出现了类似的大规模反腐行动。</p><p>目前案件仍在进一步调查中，我们将持续关注后续进展。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=serious%20government%20building%20with%20solemn%20atmosphere%2C%20Chinese%20official%20architecture%20with%20national%20emblem%2C%20overcast%20sky%2C%20dramatic%20shadows%2C%20editorial%20news%20photography%20style%2C%20clean%20minimalist%20background%20with%20strong%20vertical%20lines&width=800&height=500&seq=article-3-social&orientation=landscape',
    author: '深度调查',
    publishDate: '2026-08-02',
    viewCount: 156720,
    commentCount: 5124,
    tags: ['反腐', '调查', '社会热点', '深度'],
    isHot: true,
    isNew: false,
  },
  {
    id: '4',
    title: '某上市公司财务造假被曝光，股价单日暴跌40%散户损失惨重',
    excerpt: '做空机构发布长达80页的调查报告，指控该公司通过虚构交易虚增营收。证监会已宣布介入调查，公司股票临时停牌。',
    content: `<p>一家知名做空机构今日发布了一份长达80页的调查报告，指控某A股上市公司存在严重的财务造假行为。报告称该公司通过虚构关联交易、虚增应收账款等方式，在过去三年内累计虚增营收超过50亿元。</p><p>报告发布后，该公司股价应声暴跌，当日跌幅达到40%，市值蒸发超过200亿元。大量散户投资者遭受重大损失，社交平台上出现了大量维权声音。</p><p>一位持有该公司股票的投资者情绪激动地表示："我是看了券商研报才买的，谁能想到会有这种事？这可是我攒了三年的钱啊！"</p><p>证监会在当日下午宣布，已对该公司启动立案调查程序，公司股票自次日起临时停牌。这是今年以来第三起被做空机构狙击的A股上市公司案例。</p><p>法律界人士提醒投资者，如最终证实公司存在财务造假行为，受损投资者可以通过法律途径维权索赔。</p>`,
    category: '财经内幕',
    categorySlug: 'caijing',
    imageUrl: 'https://readdy.ai/api/search-image?query=stock%20market%20data%20display%20with%20red%20falling%20numbers%2C%20financial%20trading%20floor%20atmosphere%2C%20dramatic%20lighting%20with%20dark%20background%2C%20professional%20business%20photography%20style%20with%20warm%20accent%20lights%20and%20depth%20of%20field&width=800&height=500&seq=article-4-finance&orientation=landscape',
    author: '财经观察',
    publishDate: '2026-08-01',
    viewCount: 213450,
    commentCount: 8723,
    tags: ['财经', '股市', '造假', '投资'],
    isHot: true,
    isNew: false,
  },
  {
    id: '5',
    title: '某网红餐厅后厨卫生状况堪忧，暗访视频曝光触目惊心',
    excerpt: '记者暗访发现，该网红连锁餐厅后厨存在食材过期、蟑螂横行、员工无健康证等问题。目前市场监管部门已介入调查。',
    content: `<p>经过一周的深入暗访，本报记者在某知名网红连锁餐厅的后厨拍摄到了令人触目惊心的画面。这家在社交平台上拥有数百万粉丝的餐厅，后厨卫生状况与其光鲜亮丽的前厅形成了鲜明对比。</p><p>暗访视频显示，后厨地面油污遍布，蟑螂在食材储存区自由穿梭。更令人担忧的是，部分食材已经明显过期变质，但仍被厨师用于制作菜品。此外，多名后厨工作人员无法出示有效的健康证明。</p><p>一位曾在餐厅工作的前员工透露："老板为了节省成本，要求我们能用就用，过期的食材只要没明显变质就继续用。我们自己也从来不吃店里的东西。"</p><p>视频曝光后，当地市场监管部门已紧急介入调查，该餐厅所有门店被要求暂停营业接受全面检查。社交平台上，大量消费者表达了愤怒和担忧。</p><p>此事件再次引发了公众对食品安全问题的关注。</p>`,
    category: '生活趣闻',
    categorySlug: 'shenghuo',
    imageUrl: 'https://readdy.ai/api/search-image?query=restaurant%20kitchen%20interior%20with%20dim%20lighting%2C%20dark%20moody%20atmosphere%2C%20industrial%20kitchen%20equipment%2C%20investigative%20journalism%20style%20photography%2C%20warm%20overhead%20lights%20creating%20shadows%2C%20realistic%20documentary%20aesthetic&width=800&height=500&seq=article-5-life&orientation=landscape',
    author: '民生记者',
    publishDate: '2026-07-31',
    viewCount: 187320,
    commentCount: 6542,
    tags: ['食品安全', '暗访', '网红店', '曝光'],
    isHot: true,
    isNew: false,
  },
  {
    id: '6',
    title: '某顶流运动员被曝与教练不和，队内矛盾升级或影响奥运备战',
    excerpt: '据队内人士透露，该运动员与主教练在训练理念上存在严重分歧，已多次发生争执。这一内部矛盾可能对即将到来的国际大赛产生不利影响。',
    content: `<p>距离国际大赛仅剩数月，某国家队却传出了不和谐的声音。据队内知情人士爆料，一位被视为夺金热门的顶流运动员与其主教练之间的矛盾已经公开化。</p><p>消息人士称，矛盾的根源在于训练理念的分歧。教练倾向于采用更为保守的训练方案以确保稳定发挥，而运动员则希望尝试更具突破性的技术动作。两人在近期的训练中已多次发生正面冲突。</p><p>"这种情况很少见，"一位前国家队成员表示，"在大赛前夕，队伍内部的稳定比什么都重要。如果处理不好，影响的不仅是一个人，而是整支队伍的士气。"</p><p>体育管理部门已经知晓此事，并派出专人进行调解。但截至目前，双方似乎仍未达成一致。外界普遍担心，如果矛盾持续升级，可能会影响国家队在即将到来的国际大赛中的整体表现。</p>`,
    category: '体育赛事',
    categorySlug: 'tiyu',
    imageUrl: 'https://readdy.ai/api/search-image?query=sports%20training%20facility%20with%20professional%20atmosphere%2C%20indoor%20arena%20with%20dramatic%20lighting%2C%20athletic%20training%20equipment%2C%20sports%20photography%20style%20with%20warm%20tones%20and%20motion%20feeling&width=800&height=500&seq=article-6-sports&orientation=landscape',
    author: '体育内幕',
    publishDate: '2026-07-30',
    viewCount: 98560,
    commentCount: 3124,
    tags: ['体育', '国家队', '内讧', '奥运'],
    isHot: false,
    isNew: false,
  },
  {
    id: '7',
    title: '某知名综艺节目录制现场发生意外，嘉宾受伤送医引关注',
    excerpt: '据悉，事故发生在节目游戏环节中，一名女嘉宾在完成高难度动作时不慎摔倒。节目组已暂停录制，并表示将承担全部医疗费用。',
    content: `<p>正在热播的某档大型综艺节目近日在录制过程中突发意外。一名女嘉宾在参与一个高难度游戏环节时，因安全防护措施不到位而不慎从约两米高的平台上摔落。</p><p>现场目击者称，事故发生后现场一度混乱，工作人员迅速呼叫了救护车。该嘉宾被紧急送往附近医院进行救治，初步诊断为脚踝骨折和轻微脑震荡。</p><p>节目组随后发布声明，表示对此次意外深感抱歉，将承担该嘉宾的全部医疗费用，并对所有游戏环节进行安全审查。同时，节目录制工作暂时中止。</p><p>网友们对此反应不一。有人批评节目组为了收视率设置过于危险的游戏环节，也有人认为嘉宾自身也应更加注意安全。该事件再次将综艺节目安全保障问题推到了舆论的风口浪尖。</p>`,
    category: '娱乐爆料',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20colorful%20stage%20lighting%2C%20variety%20show%20production%20scene%2C%20bright%20spotlights%20and%20camera%20equipment%2C%20entertainment%20industry%20atmosphere%2C%20professional%20studio%20photography%20with%20vibrant%20warm%20tones&width=800&height=500&seq=article-7-variety&orientation=landscape',
    author: '综艺观察',
    publishDate: '2026-07-29',
    viewCount: 76940,
    commentCount: 2134,
    tags: ['综艺', '事故', '安全', '娱乐圈'],
    isHot: false,
    isNew: false,
  },
  {
    id: '8',
    title: '某社交平台被曝大规模泄露用户数据，涉及超5000万账号',
    excerpt: '网络安全研究人员发现，某知名社交平台的一个数据库存在严重安全漏洞，导致大量用户手机号、邮箱等隐私信息被公开。平台方已紧急修复漏洞。',
    content: `<p>网络安全圈今日传来重磅消息。一位独立安全研究人员在例行安全审计中，发现了某拥有数亿用户的社交平台存在一个严重的数据安全漏洞。该漏洞导致超过5000万个用户账号的敏感信息可以被公开访问。</p><p>泄露的数据包括用户的手机号码、电子邮箱地址、注册IP以及部分用户的真实姓名和地理位置信息。研究人员表示，他已经在发现漏洞的第一时间通知了该平台的安全团队。</p><p>该平台随后发布声明，确认了这一安全漏洞的存在，并表示已经完成了紧急修复。声明称："我们高度重视用户数据安全，已对相关系统进行了全面审查，目前没有证据表明该漏洞被恶意利用。"</p><p>然而，网络安全专家对此持谨慎态度。"漏洞存在了多久？有多少人在这期间访问过这些数据？这些都是需要回答的问题，"一位不愿透露姓名的安全专家表示。</p><p>此事件再次提醒公众，在网络时代保护个人隐私的重要性。</p>`,
    category: '科技数码',
    categorySlug: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=server%20room%20with%20blinking%20lights%20and%20cables%2C%20data%20center%20interior%2C%20cybersecurity%20theme%2C%20dark%20atmosphere%20with%20blue%20and%20red%20indicator%20lights%2C%20technology%20photography%20style%20with%20dramatic%20lighting&width=800&height=500&seq=article-8-data&orientation=landscape',
    author: '安全前线',
    publishDate: '2026-07-28',
    viewCount: 142560,
    commentCount: 4567,
    tags: ['数据泄露', '网络安全', '社交平台', '隐私'],
    isHot: true,
    isNew: false,
  },
  {
    id: '9',
    title: '某地产巨头资金链断裂传闻四起，多地项目停工引发业主维权',
    excerpt: '近日，关于某头部房企资金链紧张的传闻持续发酵。多个城市的在建项目出现停工现象，数百名业主聚集在售楼处要求开发商给出明确交房时间。',
    content: `<p>房地产行业的寒潮似乎还在持续。近日，关于某头部房企资金链断裂的传闻在业内广泛传播。虽然该公司多次出面辟谣，但多地项目停工的事实似乎说明问题并不简单。</p><p>记者实地走访发现，该房企在三个省会城市的在建项目均已停工超过两个月。工地现场杂草丛生，塔吊静止不动，建筑材料散落一地。数百名已购房的业主多次到售楼处和当地住建部门维权。</p><p>一位等待交房已超过一年的业主无奈地表示："我们是全家凑的首付，每个月还要还房贷，现在房子遥遥无期，真的不知道该怎么办。"</p><p>业内人士分析，该房企的问题并非个案。在当前的市场环境下，多家民营房企都面临着不同程度的资金压力。如果市场信心不能及时恢复，类似的维权事件可能会越来越多。</p>`,
    category: '财经内幕',
    categorySlug: 'caijing',
    imageUrl: 'https://readdy.ai/api/search-image?query=unfinished%20construction%20site%20with%20stopped%20cranes%2C%20abandoned%20building%20project%2C%20overcast%20sky%2C%20real%20estate%20crisis%20theme%2C%20documentary%20photography%20style%20with%20muted%20colors%20and%20dramatic%20composition&width=800&height=500&seq=article-9-realestate&orientation=landscape',
    author: '地产观察',
    publishDate: '2026-07-27',
    viewCount: 176530,
    commentCount: 7891,
    tags: ['房地产', '资金链', '维权', '烂尾楼'],
    isHot: true,
    isNew: false,
  },
  {
    id: '10',
    title: '某知名品牌奶茶被检出违禁添加剂，多家门店被责令停业整顿',
    excerpt: '市场监管部门抽检发现，某网红奶茶品牌的多个批次产品中含有国家明令禁止使用的食品添加剂。目前涉事门店已被查封，品牌方公开致歉。',
    content: `<p>一杯奶茶引发了一场食品安全风暴。市场监管总局今日公布了最新一期的食品安全抽检结果，其中某知名奶茶品牌的多个批次产品被检出含有国家明令禁止使用的食品添加剂。</p><p>检测报告显示，涉事产品中添加了一种名为"日落黄铝色淀"的合成色素，该物质长期摄入可能对人体健康造成损害。根据我国食品安全法规定，该添加剂严禁在茶饮类产品中使用。</p><p>消息公布后，各地市场监管部门迅速行动，对该品牌的数百家门店进行了突击检查。截至目前，已有超过50家门店被责令停业整顿。品牌方在官方社交账号上发布了致歉声明，承诺将全面整改。</p><p>消费者对此反应强烈。一位常买该品牌奶茶的大学生说："我基本上每周都要喝两三杯，现在想想真的后怕。这些企业赚钱可以，但不能拿消费者的健康开玩笑。"</p>`,
    category: '生活趣闻',
    categorySlug: 'shenghuo',
    imageUrl: 'https://readdy.ai/api/search-image?query=bubble%20tea%20shop%20storefront%20with%20closed%20sign%2C%20commercial%20street%20scene%2C%20food%20safety%20inspection%20theme%2C%20urban%20Chinese%20city%20background%2C%20street%20photography%20style%20with%20natural%20daylight%20and%20clean%20composition&width=800&height=500&seq=article-10-milktea&orientation=landscape',
    author: '消费维权',
    publishDate: '2026-07-26',
    viewCount: 231450,
    commentCount: 9876,
    tags: ['食品安全', '奶茶', '添加剂', '曝光'],
    isHot: true,
    isNew: false,
  },
  {
    id: '11',
    title: '某流量明星被指学术造假，毕业论文查重率高达80%引发质疑',
    excerpt: '有网友挖出该明星的本科毕业论文，经查重检测发现重复率超过80%。此事迅速登上热搜，引发关于艺人学历真实性的广泛讨论。',
    content: `<p>学术诚信问题再次将一位流量明星推上风口浪尖。近日，有网友在学术数据库中发现了一位当红明星的本科毕业论文，经过查重软件检测后，结果显示该论文的重复率高达80%以上。</p><p>该论文的多个段落被指与已发表的学术文章高度雷同，部分内容甚至直接复制粘贴了网络上的公开资料而未作任何引用标注。按照高校学术规范，重复率超过30%即可能被认定为学术不端。</p><p>此事一经曝光，迅速登上了各大社交平台的热搜榜。该明星的粉丝试图为其辩护，称"演艺专业更看重实践能力"，但更多网友认为学术诚信不应因身份而有所区别。</p><p>该明星所在的院校表示，已注意到相关舆情，将按照学术规范程序进行核查。如查实存在学术不端行为，将依据相关规定严肃处理。</p>`,
    category: '娱乐爆料',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=university%20library%20interior%20with%20bookshelves%20and%20reading%20area%2C%20academic%20atmosphere%2C%20warm%20lighting%20from%20desk%20lamps%2C%20scholarly%20environment%2C%20clean%20minimalist%20photography%20with%20soft%20natural%20light&width=800&height=500&seq=article-11-academic&orientation=landscape',
    author: '学术观察',
    publishDate: '2026-07-25',
    viewCount: 198670,
    commentCount: 7654,
    tags: ['学术造假', '明星', '论文', '学历'],
    isHot: false,
    isNew: false,
  },
  {
    id: '12',
    title: '某城市地铁施工导致路面塌陷，多辆汽车陷入深坑幸无人员伤亡',
    excerpt: '事故发生在早高峰时段，一处正在施工的地铁隧道上方路面突然塌陷，形成一个直径约15米的深坑。多辆停放在路边的车辆掉入坑中。',
    content: `<p>一场惊险的事故今早在某城市中心区上演。上午8时许，一处地铁施工路段上方路面突然发生塌陷，形成了一个直径约15米、深度近10米的大坑。</p><p>据目击者描述，塌陷发生时发出了巨大的声响，路面先是有裂缝出现，随后在不到一分钟的时间内完全坍塌。幸运的是，当时正值交通管制期间，塌陷区域没有行人和行驶车辆经过。但停放在路边的多辆私家车掉入了深坑中。</p><p>事故发生后，消防、公安、市政等部门迅速赶到现场处置。周边建筑内的居民被紧急疏散。地铁公司表示，事故原因初步判断为地下施工导致地质结构变化，具体原因正在进一步调查中。</p><p>这并非该城市首次发生地铁施工导致的路面塌陷事故。去年在同一线路的另一施工段也曾发生过类似事件，当时引起了社会对地铁施工安全管理的广泛关注。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=urban%20road%20collapse%20scene%20with%20emergency%20vehicles%2C%20city%20street%20with%20barriers%20and%20rescue%20workers%2C%20dramatic%20urban%20disaster%20photography%2C%20overcast%20daylight%2C%20news%20documentary%20style%20with%20realistic%20atmosphere&width=800&height=500&seq=article-12-sinkhole&orientation=landscape',
    author: '城市观察',
    publishDate: '2026-07-24',
    viewCount: 165430,
    commentCount: 5432,
    tags: ['地铁', '塌陷', '安全事故', '城市'],
    isHot: false,
    isNew: false,
  },
  {
    id: '13',
    title: '某知名主播直播带货翻车，宣称进口产品实为国内代工',
    excerpt: '消费者购买后对比发现，该主播宣称的"原装进口"产品实际上产自国内某代工厂，且产品质量与宣传严重不符。目前已有数百名消费者发起集体投诉。',
    content: `<p>直播带货行业再次出现翻车事件。某拥有千万粉丝的头部主播近日在直播中大力推荐一款号称"欧洲原装进口"的高端护肤品，售价高达899元。然而消费者收到产品后却发现，该产品的实际产地为国内某代工厂。</p><p>更令消费者愤怒的是，经专业机构检测，该产品的实际成分与宣传严重不符，多项指标未达到国家相关标准。有消费者表示使用后出现了皮肤过敏的情况。</p><p>截至目前，已有超过500名消费者在消费者协会平台上发起了集体投诉。市场监管部门表示已对此事立案调查，如果查实存在虚假宣传行为，将依法予以严惩。</p><p>业内人士指出，直播带货行业发展迅猛，但监管相对滞后，导致虚假宣传、以次充好等问题层出不穷。消费者在购买时应保持理性，不要被夸张的宣传话术所迷惑。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20professional%20lighting%20equipment%2C%20product%20display%20table%20with%20cosmetics%2C%20modern%20streaming%20setup%2C%20e-commerce%20atmosphere%2C%20warm%20studio%20lighting%20photography&width=800&height=500&seq=article-13-livestream&orientation=landscape',
    author: '消费观察',
    publishDate: '2026-07-23',
    viewCount: 143280,
    commentCount: 6789,
    tags: ['直播带货', '虚假宣传', '消费者', '维权'],
    isHot: false,
    isNew: false,
  },
  {
    id: '14',
    title: '某电动车品牌被曝续航严重虚标，实测里程仅为宣传的一半',
    excerpt: '第三方独立测试显示，该品牌最新款电动车的实际续航里程与官方宣称相差超过50%。多位车主也反映实际使用中续航表现令人失望。',
    content: `<p>电动车续航虚标问题再次成为焦点。一家独立汽车评测机构近日发布了一份测试报告，对市面上五款热门电动车进行了真实路况续航测试。结果显示，某品牌最新款车型的实际续航里程仅为官方宣传数据的48%。</p><p>测试在标准城市道路和高速公路混合路况下进行，空调正常开启，模拟真实使用场景。该车型官方宣称续航里程为650公里，但实测结果仅为312公里，差距令人震惊。</p><p>多位真实车主也在社交平台上表达了对续航表现的不满。一位购买该车型不到半年的车主表示："买车前销售说满电能跑600多公里，结果我最多只跑过350公里。冬天开暖气的话连300公里都跑不到。"</p><p>汽车行业分析师指出，目前电动车行业普遍存在续航虚标的问题，这与我国采用的测试标准有关。CLTC标准下的测试条件与实际驾驶条件存在差异，导致官方续航数据往往比实际使用高出20%-30%。但偏差超过50%的情况确实需要引起监管部门的重视。</p>`,
    category: '科技数码',
    categorySlug: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=electric%20vehicle%20charging%20station%20with%20modern%20car%2C%20futuristic%20automotive%20scene%2C%20clean%20technology%20atmosphere%2C%20urban%20setting%20with%20neon%20lights%2C%20professional%20automotive%20photography%20style&width=800&height=500&seq=article-14-ev&orientation=landscape',
    author: '汽车频道',
    publishDate: '2026-07-22',
    viewCount: 112450,
    commentCount: 4321,
    tags: ['电动车', '续航', '虚标', '消费者'],
    isHot: false,
    isNew: false,
  },
  {
    id: '15',
    title: '某知名演员深夜发文宣布退出娱乐圈，长文透露心酸内幕引网友心疼',
    excerpt: '该演员在长文中回顾了自己二十年的演艺生涯，坦言长期遭受网络暴力和行业潜规则的压力，身心俱疲决定离开。圈内好友纷纷转发支持。',
    content: `<p>昨日深夜，一位深受观众喜爱的知名演员通过个人社交账号发布了一篇长达三千字的长文，正式宣布退出娱乐圈。这篇真情流露的文字在短短数小时内获得了数百万的转发和评论。</p><p>在长文中，该演员回顾了自己二十年的演艺生涯，从默默无闻的龙套到成为家喻户晓的明星。但光鲜的外表之下，是长期遭受网络暴力的痛苦、面对行业潜规则的无奈，以及高强度工作带来的身心俱疲。</p><p>"我已经很久没有睡过一个好觉了，"文章中写道，"每次打开手机就会看到各种恶意的评论和谣言，我感到自己正在被一点点消耗殆尽。"</p><p>该演员的多位圈内好友在看到文章后纷纷转发并表达了支持。一位曾与其合作过的导演评论道："这是一个善良的人被不善良的环境伤害了。希望退圈后的他能找到真正的快乐。"</p><p>网友们对此反应强烈，相关话题迅速登上热搜榜首。许多人在评论区表达了惋惜和不舍，同时也有人呼吁社会给予艺人更多的理解和尊重。</p>`,
    category: '娱乐爆料',
    categorySlug: 'yule',
    imageUrl: 'https://readdy.ai/api/search-image?query=theater%20stage%20with%20single%20spotlight%20and%20empty%20audience%2C%20dramatic%20lighting%2C%20melancholic%20atmosphere%2C%20performing%20arts%20theme%2C%20emotional%20artistic%20photography%20with%20deep%20shadows%20and%20warm%20single%20light%20source&width=800&height=500&seq=article-15-actor&orientation=landscape',
    author: '娱乐记者',
    publishDate: '2026-07-21',
    viewCount: 287650,
    commentCount: 12456,
    tags: ['退圈', '网络暴力', '明星', '娱乐圈'],
    isHot: true,
    isNew: false,
  },
  {
    id: '16',
    title: '某大型赛事裁判被曝收受贿赂操纵比赛结果，官方宣布启动调查',
    excerpt: '一段录音在网上流传，据称内容为某国际赛事裁判与博彩公司人员的通话，讨论操纵比赛的具体细节。国际体育组织已就此展开调查。',
    content: `<p>体育界的公信力再遭重创。一段据称记录了某国际知名赛事裁判与博彩公司人员私下交易的音频文件近日在网络上广泛传播。录音内容显示，该裁判涉嫌收受巨额贿赂，以操纵关键比赛的执法结果。</p><p>在该段长达15分钟的录音中，可以听到一个被指认为该裁判的男性声音，与另一方讨论了如何在比赛中通过有争议的判罚来影响比赛走向。录音中还提到了具体的金额——据称为50万美元。</p><p>录音曝光后，国际体育组织迅速作出反应，宣布已成立独立调查委员会对此事进行全面调查。该裁判已被暂时停职，等待调查结果。</p><p>这并非体育界首次曝出裁判腐败丑闻。近年来，足球、篮球、网球等多个体育项目都曾出现过类似的裁判操纵比赛事件，严重损害了体育竞技的公平性和公信力。</p>`,
    category: '体育赛事',
    categorySlug: 'tiyu',
    imageUrl: 'https://readdy.ai/api/search-image?query=sports%20stadium%20interior%20with%20dramatic%20lighting%2C%20empty%20field%20with%20spotlights%2C%20professional%20sports%20venue%2C%20tense%20atmosphere%2C%20wide%20angle%20photography%20with%20strong%20contrast%20and%20deep%20shadows&width=800&height=500&seq=article-16-sports2&orientation=landscape',
    author: '体育调查',
    publishDate: '2026-07-20',
    viewCount: 135620,
    commentCount: 5678,
    tags: ['体育', '裁判', '腐败', '操纵比赛'],
    isHot: false,
    isNew: false,
  },
  {
    id: '17',
    title: '某知名高校教授被举报学术不端，多篇论文涉嫌数据造假',
    excerpt: '举报材料显示，该教授在近五年内发表的十余篇论文中存在数据篡改、图片重复使用等问题。涉事期刊已启动论文审查程序。',
    content: `<p>学术界再曝丑闻。一份详细的举报材料近日被提交至某知名高校学术委员会，指控该校一位资深教授存在严重的学术不端行为。举报材料长达近百页，附有大量证据。</p><p>举报材料指出，该教授在2019年至2024年间发表的十余篇论文中，存在多处数据篡改、图表重复使用和实验结果不一致等问题。其中最为严重的一篇论文中，同一张实验数据图表被用在了三个不同的实验中。</p><p>涉及的多家国际学术期刊已被告知此事，并启动了论文审查程序。如果学术不端行为被最终确认，这些论文将面临撤稿处理。</p><p>该高校发表声明称，已成立专门调查组对举报内容进行核实，将在调查结束后公布结果。如举报属实，将依据校规和相关法律法规严肃处理。</p><p>近年来，国内高校学术不端事件频发，引发了社会对学术诚信体系的广泛关注和讨论。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=university%20campus%20building%20with%20modern%20architecture%2C%20academic%20atmosphere%2C%20Chinese%20university%20scene%2C%20clean%20minimal%20design%2C%20overcast%20day%20with%20soft%20lighting%2C%20editorial%20photography%20style&width=800&height=500&seq=article-17-academic2&orientation=landscape',
    author: '教育观察',
    publishDate: '2026-07-19',
    viewCount: 108760,
    commentCount: 3456,
    tags: ['学术不端', '高校', '造假', '论文'],
    isHot: false,
    isNew: false,
  },
  {
    id: '18',
    title: '某外卖平台骑手集体罢工要求涨薪，多地出现配送严重延迟',
    excerpt: '由于不满平台连续下调配送单价，数千名外卖骑手在多个城市发起罢工行动。大量用户反映订单无人接单或配送时间大幅延长。',
    content: `<p>一场由外卖骑手发起的罢工行动正在多个城市蔓延。据悉，由于某头部外卖平台近期连续下调配送单价并修改了奖惩机制，数千名骑手决定通过罢工来抗议。</p><p>一位参与罢工的骑手告诉记者："以前跑一单能赚6到8块钱，现在降到4块钱一单。我们每天跑十几个小时，一个月下来还不到5000块钱。平台的算法越来越苛刻，实在是没法干了。"</p><p>罢工行动已经对多个城市的餐饮外卖配送造成了明显影响。大量用户在社交平台上反映，订单长时间无人接单，或者配送时间从原来的30分钟延长到了两小时以上。</p><p>该外卖平台发表声明称，正在与骑手代表进行沟通，将认真听取骑手的诉求并尽快给出解决方案。但并未就是否会恢复配送单价给出明确答复。</p><p>劳动权益专家指出，平台经济下的灵活用工模式在给消费者带来便利的同时，也暴露出了劳动者权益保障不足的问题。</p>`,
    category: '社会热点',
    categorySlug: 'shehui',
    imageUrl: 'https://readdy.ai/api/search-image?query=delivery%20riders%20on%20electric%20scooters%20on%20urban%20street%2C%20city%20traffic%20scene%2C%20gig%20economy%20workers%2C%20documentary%20street%20photography%2C%20natural%20daylight%20with%20busy%20urban%20atmosphere&width=800&height=500&seq=article-18-delivery&orientation=landscape',
    author: '民生报道',
    publishDate: '2026-07-18',
    viewCount: 176520,
    commentCount: 8765,
    tags: ['外卖骑手', '罢工', '平台经济', '劳动权益'],
    isHot: true,
    isNew: false,
  },
  {
    id: '19',
    title: '某城市小区天价物业费引争议，业主联名要求公开账目',
    excerpt: '该高端小区物业费高达每月每平方米12元，但服务质量与收费严重不匹配。业主联名要求物业公司公开收支明细未获回应，矛盾持续升级。',
    content: `<p>天价物业费引发的业主与物业公司之间的纠纷正在某城市的一个高端住宅小区持续升级。该小区的物业费高达每月每平方米12元，一个100平方米的户型每月需缴纳物业费1200元。</p><p>然而，高昂的物业费并未换来相应的服务质量。业主们反映，小区存在安保松懈、绿化养护不到位、公共设施频繁损坏等问题。更令业主不满的是，物业公司多年来一直拒绝公开详细的收支账目。</p><p>超过200名业主已联名向物业公司提交了公开账目的要求，但截至目前未收到任何实质性回应。部分业主已开始拒缴物业费以示抗议，物业公司则以停水停电相威胁。</p><p>当地住建部门表示已注意到该小区的纠纷，将督促物业公司依法公开收支明细并提高服务质量。法律界人士建议，业主可以通过成立业主委员会来加强对物业公司的监督和制约。</p>`,
    category: '生活趣闻',
    categorySlug: 'shenghuo',
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20residential%20community%20entrance%20with%20modern%20architecture%2C%20gated%20community%20scene%2C%20Chinese%20urban%20living%2C%20clean%20landscape%20design%2C%20architectural%20photography%20with%20warm%20daylight&width=800&height=500&seq=article-19-property&orientation=landscape',
    author: '社区记者',
    publishDate: '2026-07-17',
    viewCount: 92450,
    commentCount: 3456,
    tags: ['物业费', '业主维权', '社区', '纠纷'],
    isHot: false,
    isNew: false,
  },
  {
    id: '20',
    title: '某短视频平台算法被质疑制造信息茧房，研究称青少年受影响最大',
    excerpt: '一项最新研究表明，该平台的推荐算法会不断强化用户偏见，导致青少年群体出现严重的信息窄化现象，影响了他们的世界观形成。',
    content: `<p>一项由多所高校联合开展的最新研究揭示，某短视频平台的推荐算法存在严重的"信息茧房"效应，尤其对青少年用户的影响最为显著。研究结果已发表在最新一期的《新媒体研究》期刊上。</p><p>研究团队对2000名13至18岁的青少年进行了为期六个月的追踪调查。结果显示，该平台的推荐算法会不断向用户推送与其已有观点一致的内容，导致用户接触不到多元化的信息和观点。</p><p>一位参与研究的心理学教授表示："我们观察到，使用该平台时间越长的青少年，其观点越趋向于极端化和单一化。这严重影响了他们形成全面、客观世界观的能力。"</p><p>该短视频平台回应称，已经意识到算法推荐可能带来的问题，正在开发可以增加内容多样性的新算法机制，并将在近期上线测试。</p><p>教育专家呼吁家长关注孩子的网络使用习惯，鼓励他们多接触不同类型的知识和信息，培养批判性思维能力。</p>`,
    category: '科技数码',
    categorySlug: 'keji',
    imageUrl: 'https://readdy.ai/api/search-image?query=smartphone%20screen%20showing%20social%20media%20feed%2C%20digital%20technology%20concept%2C%20modern%20mobile%20app%20interface%2C%20dark%20background%20with%20colorful%20screen%20glow%2C%20technology%20photography%20style%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=article-20-algorithm&orientation=landscape',
    author: '科技观察',
    publishDate: '2026-07-16',
    viewCount: 89760,
    commentCount: 4321,
    tags: ['短视频', '算法', '信息茧房', '青少年'],
    isHot: false,
    isNew: false,
  },
];

export const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

export const latestArticles = [...articles].sort(
  (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
);

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.categorySlug === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(article: Article, count: number = 4): Article[] {
  return articles
    .filter((a) => a.id !== article.id && a.categorySlug === article.categorySlug)
    .slice(0, count);
}